import { createFileRoute } from "@tanstack/react-router"

import { AdminDebugPage } from "@/pages/admin/debug"

export const Route = createFileRoute("/_authenticated/admin/debug")({
  component: AdminDebugPage,
})
